<template>
  <div>
    <div class="sidebar-link" v-if="keySidebarActive === 'link'">
      <div class="sidebar-link__head">
        <div class="book-viewer__sidebar__contents__wrap">
            <h3 class="sidebar__title">Liên kết</h3>
          </div>
      </div>
        <div class="sidebar__link__result">
          <div class="book-viewer__sidebar__contents__wrap">
              <b-tabs class="sidebar__tabs">
                  <b-tab active>
                      <template v-slot:title>Sách điện tử</template>
                      <div class="book-links" v-if="linkInfo && linkInfo.length > 0">
                        <vue-custom-scrollbar class="scroll-area scroll-area__sidebar" :settings="settingsViewBookSidebar">
                          <div class="item display-flex full-width" v-for="(item, index) of linkInfo" :key="index">
                            <div class="item__img">
                              <router-link :to="{ name: 'ebook-detail', params: { id: item.bookId, slug: item.slug }}">
                                <img v-lazy="item.imageUrl ? cdnUrl + item.imageUrl : ''" :alt="item.name">
                              </router-link>
                            </div>
                            <div class="item__content">
                              <h4 class="item__name font-size-16 font-sanpro-semibold primary-color-txt margin-0">
                                  <router-link :to="{ name: 'ebook-detail', params: { id: item.bookId, slug: item.slug }}" class="color-inherit">{{ item.name }}</router-link>
                              </h4>
                              <p class="item__year font-size-14 secondary-color-txt">Tái bản: {{ item.editionYear }}</p>
                              <router-link :to="{ name: 'ebook-detail', params: { id: item.bookId, slug: item.slug }}" target= '_blank' class="btn btn-main-light border-rd-20 font-size-15 font-sanpro-semibold">Đọc sách</router-link>
                            </div>
                          </div>
                        </vue-custom-scrollbar>
                      </div>
                  </b-tab>
              </b-tabs>
          </div>
        </div>
    </div>

    <div class="sidebar__info" v-if="keySidebarActive === 'info'">
      <div class="sidebar__info__head">
        <div class="book-viewer__sidebar__contents__wrap">
          <h3 class="sidebar__title">Thông tin</h3>
        </div>
      </div>
      <div class="sidebar__info__result">
        <vue-custom-scrollbar class="scroll-area scroll-area__sidebar" :settings="settingsViewBookSidebar">
          <div class="book-viewer__sidebar__contents__wrap">
            <div class="sidebar__info__list">
              <div class="item">
                <div class="item__title">Chuyên đề: </div>
                <div class="item__value">{{ dataInfo.title }}</div>
              </div>
              <div class="item">
                <div class="item__title">Chủ đề: </div>
                <div class="item__value">{{ dataInfo.title1 }}</div>
              </div>
              <div class="item">
                <div class="item__title">Số câu: </div>
                <div class="item__value">{{ dataInfo.totalQuestion }}</div>
              </div>
              <div class="item">
                <div class="item__title">Số câu đúng: </div>
                <div class="item__value">{{ dataInfo.totalQuestionAnswerTrue }}</div>
              </div>
              <div class="item">
                <div class="item__title">Số câu sai: </div>
                <div class="item__value">{{ dataInfo.totalQuestionAnswerFalse }}</div>
              </div>
              <div class="item">
                <div class="item__title">Chưa làm: </div>
                <div class="item__value">{{ dataInfo.totalQuestionNotAnswer }}</div>
              </div>
            </div>
          </div>
        </vue-custom-scrollbar>
      </div>
    </div>
  </div>
</template>

<script>
import vueCustomScrollbar from 'vue-custom-scrollbar'
import { getInfoThematicOrTherExercise, getBooksLinkForExercise } from './../../_api'
import { APP_CONFIG } from '@/utils/constants'

export default {
  name: 'SidebarInfo',
  props: {
    keySidebarActive: String,
    checkQuestionId: Object
  },
  components: {
    vueCustomScrollbar
  },
  data () {
    return {
      cdnUrl: APP_CONFIG.cdnUrl,
      settingsViewBookSidebar: {
        maxScrollbarLength: 300
      },
      dataInfo: {},
      linkInfo: []
    }
  },
  watch: {
    keySidebarActive (newVal) {
      this.getDataSidebar()
    },
    '$route.params.id': 'getDataSidebar'
  },
  methods: {
    getDataSidebar () {
      if (this.keySidebarActive === 'link') {
        this.getLinks()
      } else if (this.keySidebarActive === 'info') {
        this.getInfoExercise()
      }
    },

    getInfoExercise () {
      let self = this
      if (!self.$route.params.id || parseInt(self.$route.params.id) === 0) {
        return
      }
      getInfoThematicOrTherExercise(self.$route.params.id).then(res => {
        self.dataInfo = res ? res : {}
      })
    },

    getLinks () {
      let self = this
      if (!self.$route.params.id || parseInt(self.$route.params.id) === 0) {
        return
      }
      getBooksLinkForExercise(self.$route.params.id).then(res => {
        self.linkInfo = res ? res : []
      })
    }
  }
}
</script>

<style lang="scss" scope>
  .sidebar__info__list {
    .item {
      @extend .display-flex;
      margin-bottom: 15px;

      &__title {
        width: 45%;
        margin-right: 1%;
        @extend .secondary-color-txt;
        @extend .font-size-15;
        @extend .font-sanpro-semibold;
      }

      &__value {
        width: 54%;
        @extend .font-size-16;
        @extend .font-sanpro-light;
        @extend .primary-color-txt;
      }
    }
  }
</style>
